module.exports = __webpack_public_path__ + "static/media/lob-lodge-front.d02d6f86.jpeg";